import { AccessorsMutatorsDecorator } from "../../helpers";
import { Model } from "../../helpers";

/**
 * @class NotificationRecipient
 * @property {integer} id
 * @property {Property} property
 * @property {User} user
 * @property {string} email
 */
export class NotificationRecipient extends Model {
    
    static get validationModel() {
        
        return {
            email: {
                messages: {
                    required: 'ENTER_RECIPIENT_EMAIL_ADDRESS'
                }
            }
        }
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
}

AccessorsMutatorsDecorator('id', 'property', 'user', 'email', 'property_id', 'user_id')(NotificationRecipient);


// WEBPACK FOOTER //
// ./src/pms-api/models/notification-recipient.model.js